(() => {
  const MODULE_VERSION = "2026-08-20-cart-activity-v4";
  const CART_MUTATED_EVENT = "hadley:cart-mutated";
  const CART_MUTATING_EVENT = "hadley:cart-mutating";
  const SNAPSHOT_WRITE_HEADER = "X-Hadley-Mto-Snapshot";
  const KACHING_SURFACE_SELECTOR = "[data-hadley-mto-surface='kaching-drawer']";
  const CART_SETTLE_DELAY = 150;
  const KACHING_VARIANT_PROBE_DELAY = 120;
  const KACHING_VARIANT_PROBE_ATTEMPTS = 12;

  if (window.__hadleyCartActivityBridgeLoaded === MODULE_VERSION) {
    return;
  }
  window.__hadleyCartActivityBridgeLoaded = MODULE_VERSION;
  window.__hadleyCartMutationPending = false;

  let cartSettleTimer = 0;
  let activeCartMutationCount = 0;
  let cartChanged = false;
  let kachingVariantProbeTimer = 0;
  let kachingVariantProbeToken = 0;
  let kachingVariantHoldToken = 0;

  function shopifyRootPath() {
    try {
      const root = new URL(window.Shopify?.routes?.root || "/", window.location.origin).pathname;
      return root.endsWith("/") ? root : `${root}/`;
    } catch (error) {
      return "/";
    }
  }

  function requestDetails(input, init = {}) {
    try {
      const isRequest = typeof Request !== "undefined" && input instanceof Request;
      const url = new URL(isRequest ? input.url : String(input), window.location.origin);
      const method = String(init.method || (isRequest ? input.method : "GET") || "GET").toUpperCase();
      const requestHeaders = isRequest ? new Headers(input.headers) : new Headers();
      const initHeaders = new Headers(init.headers || {});
      const isSnapshotWrite = requestHeaders.get(SNAPSHOT_WRITE_HEADER) === "1"
        || initHeaders.get(SNAPSHOT_WRITE_HEADER) === "1";

      return { url, method, isSnapshotWrite };
    } catch (error) {
      return null;
    }
  }

  function isCartMutation(details) {
    if (
      !details
      || details.isSnapshotWrite
      || details.url.origin !== window.location.origin
      || details.method === "GET"
      || details.method === "HEAD"
    ) {
      return false;
    }

    const cartPath = `${shopifyRootPath()}cart/`;
    if (!details.url.pathname.startsWith(cartPath)) {
      return false;
    }

    const action = details.url.pathname.slice(cartPath.length).replace(/\.js$/, "");
    return ["add", "change", "update", "clear"].includes(action);
  }

  function dispatchCartActivity(type) {
    document.documentElement.dispatchEvent(new CustomEvent(type, {
      bubbles: true
    }));
  }

  function scheduleCartSettlement() {
    window.clearTimeout(cartSettleTimer);
    if (activeCartMutationCount > 0 || kachingVariantHoldToken !== 0 || !cartChanged) {
      if (activeCartMutationCount === 0 && kachingVariantHoldToken === 0 && !cartChanged) {
        window.__hadleyCartMutationPending = false;
      }
      return;
    }

    cartSettleTimer = window.setTimeout(() => {
      if (activeCartMutationCount > 0 || kachingVariantHoldToken !== 0 || !cartChanged) {
        return;
      }

      cartChanged = false;
      window.__hadleyCartMutationPending = false;
      dispatchCartActivity(CART_MUTATED_EVENT);
    }, CART_SETTLE_DELAY);
  }

  function beginCartMutation() {
    activeCartMutationCount += 1;
    window.__hadleyCartMutationPending = true;
    window.clearTimeout(cartSettleTimer);
    dispatchCartActivity(CART_MUTATING_EVENT);
  }

  function endCartMutation(changed) {
    activeCartMutationCount = Math.max(activeCartMutationCount - 1, 0);
    if (changed) {
      cartChanged = true;
    }
    scheduleCartSettlement();
  }

  function isKachingVariantControl(target) {
    if (!(target instanceof Element) || !target.matches("select, input[type='radio']")) {
      return false;
    }

    for (let ancestor = target.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
      if (ancestor.querySelector?.(KACHING_SURFACE_SELECTOR)) {
        return true;
      }
    }

    return false;
  }

  document.addEventListener("shopify:cart:lines-update", (event) => {
    if (!event?.promise || typeof event.promise.then !== "function") {
      return;
    }

    beginCartMutation();

    event.promise.then((result) => {
      const changed = !Array.isArray(result?.userErrors) || result.userErrors.length === 0;
      endCartMutation(changed);
    }).catch(() => {
      endCartMutation(false);
    });
  });

  const originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = async function(input, init) {
      const details = requestDetails(input, init);
      const cartMutation = isCartMutation(details);
      if (cartMutation) {
        beginCartMutation();
      }

      try {
        const response = await Reflect.apply(originalFetch, this, [input, init]);
        if (cartMutation) {
          endCartMutation(response.ok);
        }
        return response;
      } catch (error) {
        if (cartMutation) {
          endCartMutation(false);
        }
        throw error;
      }
    };
  }

  async function probeKachingVariantChange(previousCartKey, token, attempt = 0, candidateCartKey = "") {
    let nextCartKey = "";

    try {
      const response = await Reflect.apply(originalFetch, window, [`${shopifyRootPath()}cart.js`, {
        headers: { "Accept": "application/json" },
        cache: "no-store"
      }]);
      if (response.ok) {
        const cart = await response.json();
        nextCartKey = window.HadleyMtoLeadTime?.cartStateKey?.(cart) || "";
      }
    } catch (error) {
      // A later probe can still observe the completed Kaching cart update.
    }

    if (token !== kachingVariantProbeToken) {
      return;
    }

    let nextCandidateCartKey = "";
    if (previousCartKey && nextCartKey && nextCartKey !== previousCartKey) {
      if (nextCartKey === candidateCartKey) {
        kachingVariantHoldToken = 0;
        cartChanged = true;
        scheduleCartSettlement();
        return;
      }
      nextCandidateCartKey = nextCartKey;
    }

    if (attempt + 1 >= KACHING_VARIANT_PROBE_ATTEMPTS) {
      kachingVariantHoldToken = 0;
      scheduleCartSettlement();
      return;
    }

    kachingVariantProbeTimer = window.setTimeout(() => {
      void probeKachingVariantChange(previousCartKey, token, attempt + 1, nextCandidateCartKey);
    }, KACHING_VARIANT_PROBE_DELAY);
  }

  document.addEventListener("change", (event) => {
    if (!isKachingVariantControl(event.target)) {
      return;
    }

    const previousCartKey = window.HadleyMtoLeadTime?.currentCartKey?.() || "";
    if (!previousCartKey || typeof originalFetch !== "function") {
      return;
    }

    const token = ++kachingVariantProbeToken;
    kachingVariantHoldToken = token;
    window.__hadleyCartMutationPending = true;
    window.clearTimeout(cartSettleTimer);
    window.clearTimeout(kachingVariantProbeTimer);
    dispatchCartActivity(CART_MUTATING_EVENT);
    void probeKachingVariantChange(previousCartKey, token);
  }, true);

  if (typeof XMLHttpRequest !== "undefined") {
    const requests = new WeakMap();
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      requests.set(this, requestDetails(url, { method }));
      return Reflect.apply(originalOpen, this, [method, url, ...args]);
    };

    XMLHttpRequest.prototype.send = function(...args) {
      const details = requests.get(this);
      const cartMutation = isCartMutation(details);
      if (cartMutation) {
        beginCartMutation();
        this.addEventListener("loadend", () => {
          endCartMutation(this.status >= 200 && this.status < 300);
        }, { once: true });
      }

      try {
        return Reflect.apply(originalSend, this, args);
      } catch (error) {
        if (cartMutation) {
          endCartMutation(false);
        }
        throw error;
      }
    };
  }
})();

(() => {
  const MODULE_VERSION = "2026-08-20-cart-snapshot-v13";

  if (window.__hadleyCartReconcilerLoaded === MODULE_VERSION) {
    return;
  }
  window.__hadleyCartReconcilerLoaded = MODULE_VERSION;

  const contributors = new Map();
  let reconcilePromise = null;
  let reconcileTimer = 0;
  let checkoutNavigationStarted = false;
  window.__hadleyCheckoutNavigationStarted = false;

  function shopifyRoot() {
    const root = window.Shopify?.routes?.root || "/";
    return root.endsWith("/") ? root : `${root}/`;
  }

  function isCheckoutNavigationStarted() {
    return checkoutNavigationStarted || window.__hadleyCheckoutNavigationStarted === true;
  }

  function markCheckoutNavigationStarted() {
    checkoutNavigationStarted = true;
    window.__hadleyCheckoutNavigationStarted = true;
    window.clearTimeout(reconcileTimer);
  }

  function collectBundledSections() {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections }
    }));
    return Array.from(new Set(sections.filter(Boolean).map(String)));
  }

  function canDispatchCartChange(cart) {
    return Boolean(cart?.sections && typeof cart.sections === "object");
  }

  function dispatchCartChange(cart, baseEvent = "cart-reconciler:change") {
    if (!canDispatchCartChange(cart)) {
      return false;
    }

    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent,
        cart
      }
    }));
    return true;
  }

  async function fetchCartJson(options = {}) {
    const response = await fetch(`${shopifyRoot()}cart.js`, {
      headers: { "Accept": "application/json" },
      cache: "no-store",
      signal: options.signal
    });
    if (!response.ok) {
      throw new Error("cart_fetch_failed");
    }
    return response.json();
  }

  async function updateCart(formData, options = {}) {
    const response = await fetch(`${shopifyRoot()}cart/update.js`, {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: formData,
      signal: options.signal
    });
    const cart = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(cart?.description || "cart_update_failed");
    }
    dispatchCartChange(cart, "cart-reconciler:update");
    return cart;
  }

  async function changeLineQuantity(lineKey, quantity, options = {}) {
    const sections = collectBundledSections();
    const body = {
      id: lineKey,
      quantity,
      sections
    };
    if (window.location?.pathname) {
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${shopifyRoot()}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body),
      signal: options.signal
    });
    const cart = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(cart?.description || "cart_change_failed");
    }
    dispatchCartChange(cart);
    return cart;
  }

  async function addLine(item, options = {}) {
    const sections = collectBundledSections();
    const formData = new FormData();
    formData.set("id", String(item.id));
    formData.set("quantity", String(item.quantity || 1));
    for (const [key, value] of Object.entries(item.properties || {})) {
      formData.set(`properties[${key}]`, String(value));
    }
    if (sections.length > 0) {
      formData.set("sections", sections.join(","));
      formData.set("sections_url", window.location.pathname || "/");
    }

    const response = await fetch(`${shopifyRoot()}cart/add.js`, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: formData,
      signal: options.signal
    });
    const added = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(added?.description || "cart_add_failed");
    }

    const cart = await fetchCartJson({ signal: options.signal });
    if (added?.sections && typeof added.sections === "object") {
      cart.sections = added.sections;
    }
    dispatchCartChange(cart);
    return cart;
  }

  async function applyOperation(operation, options = {}) {
    if (!operation || typeof operation !== "object") {
      return null;
    }

    if (operation.type === "changeLineQuantity") {
      return changeLineQuantity(operation.id || operation.key, operation.quantity, options);
    }

    if (operation.type === "addLine") {
      return addLine(operation, options);
    }

    return null;
  }

  async function runContributors(options = {}) {
    if (
      window.__hadleyCartMutationPending === true
      || (isCheckoutNavigationStarted() && options.allowDuringCheckout !== true)
    ) {
      return false;
    }
    if (reconcilePromise) {
      return reconcilePromise;
    }

    reconcilePromise = (async () => {
      let changed = false;
      let cart = await fetchCartJson({ signal: options.signal });
      const activeContributors = Array.from(contributors.values())
        .filter((contributor) => !options.only || contributor.id === options.only);

      for (const contributor of activeContributors) {
        try {
          const operations = await contributor.evaluate({
            cart,
            reason: options.reason || "cart",
            signal: options.signal,
            helpers: window.HadleyCartReconciler
          });
          const normalized = Array.isArray(operations) ? operations : [];

          for (const operation of normalized) {
            const nextCart = await applyOperation(operation, { signal: options.signal });
            if (nextCart) {
              cart = nextCart;
              changed = true;
            }
          }
        } catch (error) {
          // Customer-facing cart code must fail open.
        }
      }

      return changed;
    })()
      .catch(() => false)
      .finally(() => {
        reconcilePromise = null;
      });

    return reconcilePromise;
  }

  function scheduleReconcile() {
    window.clearTimeout(reconcileTimer);
    if (
      window.__hadleyCartMutationPending === true
      || isCheckoutNavigationStarted()
      || contributors.size === 0
    ) {
      return;
    }
    reconcileTimer = window.setTimeout(() => {
      void runContributors();
    }, 120);
  }

  function registerContributor(contributor) {
    if (!contributor || typeof contributor.id !== "string" || typeof contributor.evaluate !== "function") {
      return false;
    }

    contributors.set(contributor.id, contributor);
    scheduleReconcile();
    return true;
  }

  async function debugContributors() {
    const cart = await fetchCartJson();
    const result = {};
    for (const contributor of contributors.values()) {
      if (typeof contributor.debug === "function") {
        result[contributor.id] = await contributor.debug({
          cart,
          helpers: window.HadleyCartReconciler
        });
      }
    }
    return result;
  }

  window.HadleyCartReconciler = {
    shopifyRoot,
    collectBundledSections,
    fetchCartJson,
    updateCart,
    changeLineQuantity,
    addLine,
    dispatchCartChange,
    canDispatchCartChange,
    registerContributor,
    runContributors,
    scheduleReconcile,
    isCheckoutNavigationStarted,
    markCheckoutNavigationStarted,
    debug: debugContributors
  };

  const queuedContributors = Array.isArray(window.HadleyCartContributors) ? window.HadleyCartContributors : [];
  window.HadleyCartContributors = {
    push: registerContributor
  };
  queuedContributors.forEach(registerContributor);

  document.addEventListener("cart:change", (event) => {
    if (String(event.detail?.baseEvent || "").startsWith("cart-reconciler:")) {
      return;
    }
    scheduleReconcile();
  });
  document.addEventListener("cart:refresh", scheduleReconcile);
  document.addEventListener("variant:add", scheduleReconcile);
  document.addEventListener("hadley:cart-mutated", scheduleReconcile);
  window.addEventListener("pageshow", scheduleReconcile);
  document.addEventListener("DOMContentLoaded", scheduleReconcile);
})();

(() => {
  const MODULE_VERSION = "2026-09-03-cart-snapshot-v14";

  if (
    window.__hadleyMtoLeadTimeLoaded === MODULE_VERSION
    && typeof window.HadleyMtoLeadTime?.prepareCheckoutSnapshot === "function"
  ) {
    return;
  }
  window.__hadleyMtoLeadTimeLoaded = MODULE_VERSION;

  const SNAPSHOT_ATTRIBUTE = "_mto_lt";
  const SNAPSHOT_WRITE_HEADER = "X-Hadley-Mto-Snapshot";
  const SNAPSHOT_UPDATED_EVENT = "hadley:mto-snapshot";
  const CHECKOUT_COMMIT_TIMEOUT = 3000;
  const CHECKOUT_POLL_DELAY = 50;
  const DEFAULT_MTO_RANGE = "6-8";
  const DEFAULT_READY_RANGE = "3-10d";

  let metadataCache = null;
  let metadataFetchKey = "";
  let metadataFetchPromise = null;
  let latestSnapshot = null;
  let snapshotCacheTimer = 0;
  let snapshotEvaluationId = 0;
  let persistedSnapshotPayload = null;
  let persistedSnapshotCartKey = "";
  let pendingSnapshotPayload = null;
  let pendingSnapshotCartKey = "";
  let pendingSnapshotSignal = null;
  let snapshotWriteInFlight = false;
  let snapshotWritePromise = null;
  let snapshotCommitDirty = true;
  let checkoutPreparationPromise = null;
  let checkoutReplayPending = false;
  const checkoutReplayTargets = new WeakSet();

  function shopifyRoot() {
    return window.HadleyCartReconciler?.shopifyRoot?.() || window.Shopify?.routes?.root || "/";
  }

  function normalizeRangeText(text) {
    return String(text || "")
      .trim()
      .replace(/[–—]/g, "-")
      .replace(/\u00a0/g, " ")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ");
  }

  // MTO and Personalized lead-time ranges are week ranges with no unit suffix.
  function extractRangeText(raw) {
    const normalized = normalizeRangeText(raw).replace(/\s*-\s*/g, "-");
    return /^\d+(?:-\d+)?$/.test(normalized) ? normalized : "";
  }

  // Ready-to-ship snapshots are business-day ranges and must preserve a "d" suffix.
  function extractReadyDayRangeText(raw) {
    const normalized = normalizeRangeText(raw)
      .replace(/\s*-\s*/g, "-")
      .replace(/\s+/g, "")
      .toLowerCase();
    const match = normalized.match(/^(\d+)(?:-(\d+))?d$/);
    if (!match) {
      return "";
    }

    const min = Number(match[1]);
    const max = Number(match[2] || match[1]);
    if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max < min) {
      return "";
    }
    return match[2] ? `${min}-${max}d` : `${min}d`;
  }

  function parseRange(text) {
    const normalized = extractRangeText(text);
    const match = normalized.match(/^(\d+)(?:-(\d+))?$/);
    if (!match) {
      return null;
    }

    const min = Number(match[1]);
    const max = Number(match[2] || match[1]);
    if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max < min) {
      return null;
    }
    return { text: normalized, min, max };
  }

  function isDefaultRangeValue(raw) {
    return normalizeRangeText(raw).toLowerCase() === "default";
  }

  function toSafeNumber(value) {
    if (typeof value === "number" && Number.isFinite(value)) {
      return value;
    }
    if (typeof value === "string") {
      const match = value.trim().match(/-?\d+/);
      return match ? Number(match[0]) : 0;
    }
    return 0;
  }

  function toOptionalNumber(value) {
    return typeof value === "number" && Number.isFinite(value) ? value : null;
  }

  function toOptionalBool(value) {
    return value === true || value === false ? value : null;
  }

  function shiftRange(rangeText, weeks, mtoDefaultRange) {
    const parsed = parseRange(rangeText) || parseRange(mtoDefaultRange) || { min: 6, max: 8 };
    const min = parsed.min + weeks;
    const max = parsed.max + weeks;
    return min === max ? String(min) : `${min}-${max}`;
  }

  function getValidRangeOrDefault(raw, fallback, mtoDefaultRange) {
    const parsed = parseRange(raw);
    if (parsed) {
      return parsed.text;
    }

    const fallbackParsed = parseRange(fallback);
    if (fallbackParsed) {
      return fallbackParsed.text;
    }

    return parseRange(mtoDefaultRange)?.text || DEFAULT_MTO_RANGE;
  }

  function chooseMaxRange(rangeTexts) {
    const parsed = rangeTexts.map(parseRange).filter(Boolean);
    if (!parsed.length) {
      return "";
    }

    return parsed.reduce((maxSoFar, current) => {
      if (current.max > maxSoFar.max) {
        return current;
      }
      if (current.max < maxSoFar.max) {
        return maxSoFar;
      }
      return current.min > maxSoFar.min ? current : maxSoFar;
    }).text;
  }

  function displayTitle(variant, product, item) {
    const productTitle = String(product || item?.product_title || item?.title || "").trim();
    const variantTitle = String(variant || item?.variant_title || "").trim();
    if (!variantTitle || variantTitle === "Default Title" || variantTitle === productTitle) {
      return productTitle || variantTitle || "Item";
    }
    return `${variantTitle} ${productTitle}`.trim();
  }

  function encodeSnapshotTitle(title) {
    return encodeURIComponent(String(title || "Item").replace(/\s+/g, " ").trim() || "Item");
  }

  function parseMetadataElement(el) {
    try {
      const parsed = JSON.parse(el.textContent || "{}");
      const lines = Array.isArray(parsed?.lines) ? parsed.lines : [];
      const mtoDefaultRange = extractRangeText(parsed?.defaults?.mto) || DEFAULT_MTO_RANGE;
      const persDefaultRange = extractRangeText(parsed?.defaults?.pers)
        || shiftRange(mtoDefaultRange, 2, mtoDefaultRange);
      const readyRange = extractReadyDayRangeText(parsed?.defaults?.ready) || DEFAULT_READY_RANGE;

      return {
        defaults: {
          mto: mtoDefaultRange,
          pers: persDefaultRange,
          ready: readyRange
        },
        lines
      };
    } catch (error) {
      return null;
    }
  }

  function metadataCoversCart(metadata, cart) {
    const variantIds = new Set((metadata?.lines || []).map((line) => String(line?.variant_id || "")));
    const items = Array.isArray(cart?.items) ? cart.items : [];

    return items.every((item) => {
      if (item?.requires_shipping === false || item?.gift_card === true) {
        return true;
      }
      return variantIds.has(String(item?.variant_id || item?.id || ""));
    });
  }

  function parseMetadata(root = document, cart = null) {
    const nodes = Array.from(root.querySelectorAll?.("[data-hadley-mto-data]") || []);

    for (const node of nodes) {
      const parsed = parseMetadataElement(node);
      if (parsed && (!cart || metadataCoversCart(parsed, cart))) {
        return parsed;
      }
    }

    return null;
  }

  function emptyMetadata() {
    return {
      defaults: {
        mto: DEFAULT_MTO_RANGE,
        pers: shiftRange(DEFAULT_MTO_RANGE, 2, DEFAULT_MTO_RANGE),
        ready: DEFAULT_READY_RANGE
      },
      lines: []
    };
  }

  function getCurrentMetadata(cart = null) {
    const parsed = parseMetadata(document, cart);
    if (parsed) {
      metadataCache = parsed;
      return parsed;
    }
    if (metadataCache && (!cart || metadataCoversCart(metadataCache, cart))) {
      return metadataCache;
    }
    return null;
  }

  function cartMetadataKey(cart) {
    return (cart?.items || [])
      .filter((item) => item?.requires_shipping !== false && item?.gift_card !== true)
      .map((item) => String(item?.variant_id || item?.id || ""))
      .filter(Boolean)
      .sort()
      .join("|");
  }

  function cartDrawerSectionId() {
    const drawer = document.querySelector?.("#cart-drawer");
    const section = drawer?.closest?.("[id^='shopify-section-']");
    return section?.id?.replace(/^shopify-section-/, "") || "cart-drawer";
  }

  async function fetchRenderedMetadata(cart, options = {}) {
    const key = cartMetadataKey(cart);
    if (metadataFetchPromise && metadataFetchKey === key) {
      return metadataFetchPromise;
    }

    const url = new URL(shopifyRoot(), window.location.origin);
    url.searchParams.set("section_id", cartDrawerSectionId());

    metadataFetchKey = key;
    const request = (async () => {
      const response = await fetch(url.toString(), {
        headers: { "Accept": "text/html" },
        cache: "no-store",
        signal: options.signal
      });
      if (!response.ok) {
        throw new Error("mto_metadata_fetch_failed");
      }

      const rendered = new DOMParser().parseFromString(await response.text(), "text/html");
      const parsed = parseMetadata(rendered, cart);
      if (!parsed) {
        throw new Error("mto_metadata_incomplete");
      }

      metadataCache = parsed;
      return parsed;
    })();
    metadataFetchPromise = request;

    try {
      return await request;
    } finally {
      if (metadataFetchPromise === request) {
        metadataFetchPromise = null;
        metadataFetchKey = "";
      }
    }
  }

  async function getMetadata(cart = null, options = {}) {
    const current = getCurrentMetadata(cart);
    if (current || !cart) {
      return current || emptyMetadata();
    }

    try {
      return await fetchRenderedMetadata(cart, options);
    } catch (error) {
      return emptyMetadata();
    }
  }

  async function fetchCartJson(options = {}) {
    return window.HadleyCartReconciler?.fetchCartJson
      ? window.HadleyCartReconciler.fetchCartJson(options)
      : fetch(`${shopifyRoot()}cart.js`, {
        headers: { "Accept": "application/json" },
        cache: "no-store",
        signal: options.signal
      }).then((response) => {
        if (!response.ok) {
          throw new Error("cart_fetch_failed");
        }
        return response.json();
      });
  }

  function buildMetaMap(metadata) {
    const map = new Map();
    const lines = Array.isArray(metadata?.lines) ? metadata.lines : [];

    function normalizeMeta(line) {
      const inventoryTracked = toOptionalBool(line?.inventoryTracked);
      return {
        variantId: String(line?.variant_id || ""),
        product: line?.product_title,
        variant: line?.variant_title,
        tags: Array.isArray(line?.tags) ? line.tags : [],
        quantityPerBundle: toOptionalNumber(line?.quantityPerBundle),
        inventoryTracked: inventoryTracked !== false,
        oh: toOptionalNumber(line?.oh),
        gw: toOptionalNumber(line?.gw),
        allowOversell: toOptionalBool(line?.allowOversell),
        mtoLeadTime: line?.mtoLeadTime,
        persLeadTime: line?.persLeadTime,
        requiresShipping: line?.requires_shipping !== false,
        giftCard: line?.gift_card === true
      };
    }

    for (const line of lines) {
      const variantId = String(line?.variant_id || "");
      if (!variantId) {
        continue;
      }

      const meta = normalizeMeta(line);
      meta.components = Array.isArray(line?.components) ? line.components.map(normalizeMeta) : [];
      map.set(variantId, meta);
    }

    return map;
  }

  function isPhysicalLine(item, meta) {
    const requiresShipping = item?.requires_shipping ?? meta?.requiresShipping;
    const giftCard = item?.gift_card ?? meta?.giftCard;
    return requiresShipping !== false && giftCard !== true;
  }

  function inventoryPoolFor(meta, inventoryPools) {
    if (!meta?.variantId || meta.oh === null) {
      return null;
    }
    if (!inventoryPools.has(meta.variantId)) {
      inventoryPools.set(meta.variantId, {
        oh: Math.max(meta.oh, 0),
        gw: meta.gw === null ? null : Math.max(meta.gw, 0),
        allowOversell: meta.allowOversell
      });
    }
    return inventoryPools.get(meta.variantId);
  }

  function computeLineState(item, meta, inventoryPools) {
    const qty = toSafeNumber(item?.quantity || item?.qty);

    if (qty <= 0 || meta?.inventoryTracked === false) {
      return { state: "ready", qty, ohReady: Math.max(qty, 0), mtoCount: 0 };
    }
    const pool = inventoryPoolFor(meta, inventoryPools);
    if (!pool) {
      return { state: "unknown", qty, ohReady: 0, mtoCount: 0 };
    }

    const ohReady = Math.min(qty, pool.oh);
    pool.oh -= ohReady;
    const remainingAfterOH = qty - ohReady;
    if (remainingAfterOH === 0) {
      return { state: "ready", qty, ohReady, mtoCount: 0 };
    }
    if (pool.gw === null) {
      return { state: "unknown", qty, ohReady, mtoCount: 0 };
    }

    const mtoCovered = Math.min(remainingAfterOH, pool.gw);
    pool.gw -= mtoCovered;
    if (mtoCovered === remainingAfterOH) {
      return {
        state: "mto",
        qty,
        ohReady,
        mtoCount: remainingAfterOH
      };
    }

    if (pool.allowOversell === true) {
      return {
        state: "oversell",
        qty,
        ohReady,
        mtoCount: remainingAfterOH
      };
    }

    return { state: "unknown", qty, ohReady, mtoCount: 0 };
  }

  function getLineLeadTimeRange(meta, state, mtoDefaultRange, persDefaultRange) {
    const isPersonalized = meta.tags.includes("Personalized");
    const mtoFloor = isDefaultRangeValue(meta.mtoLeadTime)
      ? mtoDefaultRange
      : getValidRangeOrDefault(meta.mtoLeadTime, mtoDefaultRange, mtoDefaultRange);

    if (!isPersonalized) {
      return state === "oversell" ? shiftRange(mtoFloor, 2, mtoDefaultRange) : mtoFloor;
    }

    const personalizedFallback = shiftRange(mtoFloor, 2, mtoDefaultRange);
    const personalizedFloor = isDefaultRangeValue(meta.persLeadTime)
      ? persDefaultRange
      : getValidRangeOrDefault(meta.persLeadTime, personalizedFallback, mtoDefaultRange);

    return state === "oversell" ? shiftRange(personalizedFloor, 2, mtoDefaultRange) : personalizedFloor;
  }

  function computeBundleLineState(item, meta, inventoryPools, mtoDefaultRange, persDefaultRange) {
    const qty = toSafeNumber(item?.quantity || item?.qty);
    if (qty <= 0) {
      return { state: "ready", qty, ohReady: 0, mtoCount: 0, safeRange: "" };
    }

    let readyBundles = qty;
    let hasOversell = false;
    const ranges = [];

    for (const component of meta.components) {
      const unitsPerBundle = component.quantityPerBundle;
      if (!Number.isInteger(unitsPerBundle) || unitsPerBundle <= 0) {
        return { state: "unknown", qty, ohReady: 0, mtoCount: 0, safeRange: "" };
      }

      const componentQuantity = unitsPerBundle * qty;
      const componentState = computeLineState({ quantity: componentQuantity }, component, inventoryPools);
      if (componentState.state === "unknown") {
        return { state: "unknown", qty, ohReady: 0, mtoCount: 0, safeRange: "" };
      }

      readyBundles = Math.min(
        readyBundles,
        Math.floor(componentState.ohReady / unitsPerBundle)
      );
      if (componentState.state === "ready") {
        continue;
      }

      hasOversell ||= componentState.state === "oversell";
      const rangeMeta = meta.tags.includes("Personalized") && !component.tags.includes("Personalized")
        ? { ...component, tags: [...component.tags, "Personalized"] }
        : component;
      ranges.push(getLineLeadTimeRange(
        rangeMeta,
        componentState.state,
        mtoDefaultRange,
        persDefaultRange
      ));
    }

    const mtoCount = Math.max(qty - readyBundles, 0);
    if (ranges.length === 0 || mtoCount === 0) {
      return { state: "ready", qty, ohReady: qty, mtoCount: 0, safeRange: "" };
    }

    return {
      state: hasOversell ? "oversell" : "mto",
      qty,
      ohReady: readyBundles,
      mtoCount,
      safeRange: chooseMaxRange(ranges)
    };
  }

  function buildOverageRows(cartItems, metadata) {
    const rows = [];
    const metaMap = buildMetaMap(metadata);
    const inventoryPools = new Map();
    const mtoDefaultRange = extractRangeText(metadata?.defaults?.mto) || DEFAULT_MTO_RANGE;
    const persDefaultRange = extractRangeText(metadata?.defaults?.pers)
      || shiftRange(mtoDefaultRange, 2, mtoDefaultRange);
    let missingPhysicalMetadataCount = 0;
    let unhandledLeadTimeCount = 0;
    let physicalLineCount = 0;

    for (const item of cartItems || []) {
      const variantId = String(item?.variant_id || item?.id || "");
      const meta = metaMap.get(variantId);
      const physicalLine = isPhysicalLine(item, meta);
      if (!physicalLine) {
        continue;
      }

      physicalLineCount += 1;
      if (!meta) {
        missingPhysicalMetadataCount += 1;
        continue;
      }

      const state = meta.components.length > 0
        ? computeBundleLineState(item, meta, inventoryPools, mtoDefaultRange, persDefaultRange)
        : computeLineState(item, meta, inventoryPools);
      if (state.state === "unknown") {
        unhandledLeadTimeCount += 1;
        continue;
      }
      if (state.state === "ready") {
        continue;
      }

      rows.push({
        title: displayTitle(meta.variant, meta.product, item),
        state: state.state,
        ohReady: state.ohReady,
        mtoCount: state.mtoCount,
        safeRange: state.safeRange
          || getLineLeadTimeRange(meta, state.state, mtoDefaultRange, persDefaultRange),
        key: String(item?.key || ""),
        variantId
      });
    }

    return {
      overages: rows,
      physicalLineCount,
      metadataComplete: missingPhysicalMetadataCount === 0 && unhandledLeadTimeCount === 0
    };
  }

  function computeOverages(cartItems, metadata) {
    return buildOverageRows(cartItems, metadata).overages;
  }

  function cartStateKey(cart) {
    return (cart?.items || []).map((item) => {
      const key = item?.key || item?.variant_id || item?.id || "";
      return `${key}:${toSafeNumber(item?.quantity)}`;
    }).join("|");
  }

  function computeSnapshot(cart, metadata) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const readyRange = extractReadyDayRangeText(metadata?.defaults?.ready) || DEFAULT_READY_RANGE;
    const rowResult = buildOverageRows(items, metadata);

    if (!rowResult.metadataComplete || rowResult.physicalLineCount === 0) {
      return {
        payload: "",
        overages: rowResult.overages,
        metadataComplete: false,
        readyRange,
        cartKey: cartStateKey(cart)
      };
    }

    const rows = ["v1", `ready,${readyRange}`];
    for (const overage of rowResult.overages) {
      rows.push([
        "item",
        overage.mtoCount,
        overage.safeRange,
        overage.state,
        overage.ohReady,
        encodeSnapshotTitle(overage.title)
      ].join(","));
    }

    return {
      payload: rows.join("|"),
      overages: rowResult.overages,
      metadataComplete: true,
      readyRange,
      cartKey: cartStateKey(cart)
    };
  }

  async function writeCartAttribute(value, options = {}) {
    const formData = new FormData();
    formData.set(`attributes[${SNAPSHOT_ATTRIBUTE}]`, String(value || ""));

    let lastError = new Error("cart_attribute_update_failed");
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        const response = await fetch(`${shopifyRoot()}cart/update.js`, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            [SNAPSHOT_WRITE_HEADER]: "1"
          },
          body: formData,
          signal: options.signal
        });
        if (response.ok) {
          const cart = await response.json();
          if (String(cart?.attributes?.[SNAPSHOT_ATTRIBUTE] || "") !== String(value || "")) {
            throw new Error("cart_attribute_verification_failed");
          }
          return cart;
        }
      } catch (error) {
        lastError = error;
      }

      if (options.signal?.aborted) {
        throw lastError;
      }
      if (attempt === 0) {
        await new Promise((resolve) => window.setTimeout(resolve, 200));
      }
    }

    throw lastError;
  }

  function rememberSnapshot(snapshot) {
    latestSnapshot = snapshot;
    return snapshot;
  }

  function publishSnapshot(snapshot) {
    document.documentElement.dispatchEvent(new CustomEvent(SNAPSHOT_UPDATED_EVENT, {
      bubbles: true,
      detail: { snapshot }
    }));
  }

  function snapshotPayloadForWrite(snapshot) {
    return snapshot?.metadataComplete ? String(snapshot.payload || "") : null;
  }

  async function flushSnapshotWrite() {
    if (snapshotWriteInFlight) {
      return snapshotWritePromise || false;
    }
    if (pendingSnapshotPayload === null) {
      return false;
    }

    snapshotWriteInFlight = true;

    snapshotWritePromise = (async () => {
      let changed = false;
      let failed = false;
      let writingPayload = null;
      let writingCartKey = "";
      let writingSignal = null;
      try {
        while (pendingSnapshotPayload !== null) {
          writingPayload = pendingSnapshotPayload;
          writingCartKey = pendingSnapshotCartKey;
          writingSignal = pendingSnapshotSignal;
          pendingSnapshotPayload = null;
          pendingSnapshotCartKey = "";
          pendingSnapshotSignal = null;
          const writtenCart = await writeCartAttribute(writingPayload, { signal: writingSignal });
          if (cartStateKey(writtenCart) !== writingCartKey) {
            throw new Error("cart_snapshot_write_race");
          }
          persistedSnapshotPayload = writingPayload;
          persistedSnapshotCartKey = writingCartKey;
          changed = true;
        }

        return changed;
      } catch (error) {
        failed = true;
        return false;
      } finally {
        snapshotWriteInFlight = false;
        snapshotWritePromise = null;
        if (!failed && pendingSnapshotPayload !== null) {
          void flushSnapshotWrite();
        }
      }
    })();

    return snapshotWritePromise;
  }

  async function queueSnapshotWrite(snapshot, options = {}) {
    const payload = options.clearIncomplete === true && !snapshot?.metadataComplete
      ? ""
      : snapshotPayloadForWrite(snapshot);
    const cartKey = String(snapshot?.cartKey || "");
    if (payload === null) {
      return false;
    }

    pendingSnapshotPayload = payload;
    pendingSnapshotCartKey = cartKey;
    pendingSnapshotSignal = options.signal || null;
    await flushSnapshotWrite();
    return persistedSnapshotPayload === payload && persistedSnapshotCartKey === cartKey;
  }

  async function getProposedSnapshot(options = {}) {
    const cart = await fetchCartJson({ signal: options.signal });
    const metadata = await getMetadata(cart, { signal: options.signal });
    return computeSnapshot(cart, metadata);
  }

  async function getProposedOverages(options = {}) {
    const snapshot = await getProposedSnapshot(options);
    return snapshot.metadataComplete ? snapshot.overages : [];
  }

  function expectedCommittedPayload(snapshot, clearIncomplete = false) {
    if (snapshot?.metadataComplete) {
      return String(snapshot.payload || "");
    }
    return clearIncomplete ? "" : null;
  }

  function isSnapshotReadyForCheckout(snapshot = latestSnapshot) {
    if (
      !snapshot
      || snapshotCommitDirty
      || window.__hadleyCartMutationPending === true
      || snapshotWriteInFlight
      || pendingSnapshotPayload !== null
    ) {
      return false;
    }

    const expectedPayload = expectedCommittedPayload(snapshot, true);
    return persistedSnapshotPayload === expectedPayload
      && persistedSnapshotCartKey === String(snapshot.cartKey || "");
  }

  async function refreshSnapshotCache(options = {}) {
    if (window.__hadleyCartMutationPending === true) {
      return latestSnapshot;
    }

    const evaluationId = ++snapshotEvaluationId;
    const cart = await fetchCartJson({ signal: options.signal });
    const cartKey = cartStateKey(cart);
    const metadata = await getMetadata(cart, { signal: options.signal });
    const verifiedCart = await fetchCartJson({ signal: options.signal });
    if (
      evaluationId !== snapshotEvaluationId
      || window.__hadleyCartMutationPending === true
      || cartStateKey(verifiedCart) !== cartKey
    ) {
      scheduleSnapshotCacheRefresh(100);
      return latestSnapshot;
    }

    const snapshot = computeSnapshot(verifiedCart, metadata);
    const clearIncomplete = options.clearIncomplete === true;
    let commitVerified = options.persist === false;

    if (options.persist !== false) {
      const payload = expectedCommittedPayload(snapshot, clearIncomplete);
      const currentPayload = String(verifiedCart?.attributes?.[SNAPSHOT_ATTRIBUTE] || "");

      if (payload === null) {
        pendingSnapshotPayload = null;
        pendingSnapshotCartKey = "";
        pendingSnapshotSignal = null;
      } else if (currentPayload === payload) {
        persistedSnapshotPayload = payload;
        persistedSnapshotCartKey = snapshot.cartKey;
        pendingSnapshotPayload = null;
        pendingSnapshotCartKey = "";
        pendingSnapshotSignal = null;
        commitVerified = true;
      } else {
        commitVerified = await queueSnapshotWrite(snapshot, {
          clearIncomplete,
          signal: options.signal
        });
      }
    }

    if (evaluationId !== snapshotEvaluationId || window.__hadleyCartMutationPending === true) {
      snapshotCommitDirty = true;
      scheduleSnapshotCacheRefresh(100);
      return latestSnapshot;
    }

    if (options.persist === false) {
      return snapshot;
    }

    if (!commitVerified && expectedCommittedPayload(snapshot, clearIncomplete) !== null) {
      snapshotCommitDirty = true;
      return latestSnapshot;
    }

    snapshotCommitDirty = !commitVerified;
    rememberSnapshot(snapshot);
    publishSnapshot(snapshot);
    return snapshot;
  }

  function invalidateSnapshotEvaluation() {
    snapshotEvaluationId += 1;
    snapshotCommitDirty = true;
    window.clearTimeout(snapshotCacheTimer);
  }

  function scheduleSnapshotCacheRefresh(delay = 250) {
    const wait = typeof delay === "number" ? delay : 250;
    window.clearTimeout(snapshotCacheTimer);
    if (window.__hadleyCartMutationPending === true) {
      return;
    }
    snapshotCacheTimer = window.setTimeout(() => {
      void refreshSnapshotCache({ waitForWrite: true }).catch(() => {
        // Customer-facing cart code must fail open.
      });
    }, wait);
  }

  function waitForCartIdle(signal) {
    return new Promise((resolve, reject) => {
      let timer = 0;

      const finish = (error = null) => {
        window.clearTimeout(timer);
        signal?.removeEventListener("abort", onAbort);
        error ? reject(error) : resolve();
      };
      const onAbort = () => finish(new Error("checkout_snapshot_timeout"));
      const poll = () => {
        if (signal?.aborted) {
          onAbort();
          return;
        }
        if (window.__hadleyCartMutationPending !== true) {
          finish();
          return;
        }
        timer = window.setTimeout(poll, CHECKOUT_POLL_DELAY);
      };

      signal?.addEventListener("abort", onAbort, { once: true });
      poll();
    });
  }

  function prepareCheckoutSnapshot() {
    if (checkoutPreparationPromise) {
      return checkoutPreparationPromise;
    }

    const controller = new AbortController();
    let timeout = 0;
    const work = (async () => {
      while (!controller.signal.aborted) {
        await waitForCartIdle(controller.signal);
        invalidateSnapshotEvaluation();
        const snapshot = await refreshSnapshotCache({
          signal: controller.signal,
          clearIncomplete: true
        });
        if (isSnapshotReadyForCheckout(snapshot)) {
          return true;
        }
        await new Promise((resolve) => window.setTimeout(resolve, CHECKOUT_POLL_DELAY));
      }
      return false;
    })().catch(() => false);

    const deadline = new Promise((resolve) => {
      timeout = window.setTimeout(() => {
        controller.abort();
        resolve(false);
      }, CHECKOUT_COMMIT_TIMEOUT);
    });

    checkoutPreparationPromise = Promise.race([work, deadline]).finally(() => {
      window.clearTimeout(timeout);
      checkoutPreparationPromise = null;
    });
    return checkoutPreparationPromise;
  }

  function replayCheckout(target) {
    const currentTarget = target?.isConnected
      ? target
      : target?.id
        ? document.getElementById(target.id)
        : document.querySelector?.('[name="checkout"], a[href*="/checkout"]');

    if (currentTarget?.click) {
      try {
        checkoutReplayTargets.add(currentTarget);
        currentTarget.click();
        return;
      } catch (error) {
        checkoutReplayTargets.delete(currentTarget);
      }
    }

    window.location.assign(`${shopifyRoot()}checkout`);
  }

  function handleCheckoutClick(event) {
    const target = event.target instanceof Element
      ? event.target.closest('[name="checkout"], a[href*="/checkout"]')
      : null;
    if (!target) {
      return;
    }

    if (checkoutReplayTargets.has(target)) {
      checkoutReplayTargets.delete(target);
      return;
    }

    if (isSnapshotReadyForCheckout()) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutReplayPending) {
      return;
    }

    checkoutReplayPending = true;
    void prepareCheckoutSnapshot().finally(() => {
      checkoutReplayPending = false;
      replayCheckout(target);
    });
  }

  window.HadleyMtoLeadTime = {
    attributeName: SNAPSHOT_ATTRIBUTE,
    chooseMaxRange,
    getMetadata,
    fetchCartJson,
    computeOverages,
    computeSnapshot,
    metadataCoversCart,
    getProposedSnapshot,
    getProposedOverages,
    refreshSnapshotCache,
    prepareCheckoutSnapshot,
    isSnapshotReadyForCheckout,
    currentSnapshot: () => latestSnapshot,
    currentCartKey: () => String(latestSnapshot?.cartKey || ""),
    cartStateKey
  };

  document.addEventListener("hadley:cart-mutating", invalidateSnapshotEvaluation);
  document.addEventListener("cart:change", scheduleSnapshotCacheRefresh);
  document.addEventListener("cart:refresh", scheduleSnapshotCacheRefresh);
  document.addEventListener("variant:add", scheduleSnapshotCacheRefresh);
  document.addEventListener("hadley:cart-mutated", () => scheduleSnapshotCacheRefresh(0));
  document.addEventListener("click", handleCheckoutClick, true);
  window.addEventListener("pageshow", scheduleSnapshotCacheRefresh);
  document.addEventListener("DOMContentLoaded", scheduleSnapshotCacheRefresh);
  scheduleSnapshotCacheRefresh();
})();

(() => {
  const MODULE_VERSION = "2026-08-19-cart-toast-v5";

  if (window.__hadleyMtoToastLoaded === MODULE_VERSION) {
    return;
  }
  window.__hadleyMtoToastLoaded = MODULE_VERSION;

  const registry = window.__hadleyMtoToastRegistry || {};
  const dismissedBySurface = window.__hadleyMtoToastDismissedBySurface || {};
  const toastStates = new WeakMap();

  window.__hadleyMtoToastRegistry = registry;
  window.__hadleyMtoToastDismissedBySurface = dismissedBySurface;

  function isCartPage() {
    return window.themeVariables?.settings?.pageType === "cart" || document.body?.className?.includes("template-cart");
  }

  function hideToast(state) {
    state.toast.hidden = true;
  }

  function escapeHTML(value) {
    const el = document.createElement("span");
    el.textContent = String(value || "");
    return el.innerHTML;
  }

  function pluralize(count, singular, plural) {
    return Number(count) === 1 ? singular : plural;
  }

  function titleList(overages, maxRange) {
    const matching = overages.filter((overage) => overage.safeRange === maxRange);
    const source = matching.length ? matching : overages;
    const names = source.slice(0, 2).map((overage) => overage.title).filter(Boolean);

    if (!names.length) {
      return "these pieces";
    }
    if (source.length > names.length) {
      return `${names.join(", ")} and ${source.length - names.length} more`;
    }
    return names.join(" and ");
  }

  function lineText(overage) {
    const title = escapeHTML(overage.title);
    const readyCount = Number(overage.ohReady || 0);
    const mtoCount = Number(overage.mtoCount || 0);
    const range = overage.safeRange ? ` <span class="hadley-toast__range">(${escapeHTML(overage.safeRange)} weeks)</span>` : "";

    if (readyCount > 0) {
      return `${title}: <strong>${readyCount}</strong> ${pluralize(readyCount, "is", "are")} ready to ship; <strong>${mtoCount}</strong> will be made to order${range}`;
    }

    return `${title}: <strong>${mtoCount}</strong> will be made to order${range}`;
  }

  function renderToast(state, snapshot) {
    const overages = Array.isArray(snapshot?.overages) ? snapshot.overages : [];
    const nextCartKey = String(snapshot?.cartKey || "");

    if (nextCartKey !== state.currentCartKey) {
      state.expanded = false;
    }
    state.currentCartKey = nextCartKey;
    state.lastSnapshot = snapshot;

    if (!snapshot?.metadataComplete || !overages.length || dismissedBySurface[state.surfaceKey] === state.currentCartKey) {
      hideToast(state);
      return;
    }

    const totalMTO = overages.reduce((sum, overage) => sum + Number(overage.mtoCount || 0), 0);
    const maxRange = window.HadleyMtoLeadTime?.chooseMaxRange?.(overages.map((overage) => overage.safeRange)) || overages[0]?.safeRange || "";
    const hasOversell = overages.some((overage) => overage.state === "oversell");
    const maxTitleText = titleList(overages, maxRange);
    const visibleLimit = state.inDrawer ? 2 : 3;

    if (state.header) {
      if (overages.length === 1) {
        const rangeText = overages[0].safeRange ? `${overages[0].safeRange} weeks` : "the current lead time";
        state.header.textContent = hasOversell
          ? `${overages[0].title} has an extended made to order lead time of ${rangeText}.`
          : `${overages[0].title} will be made to order. Current lead time: ${rangeText}.`;
      } else if (hasOversell) {
        state.header.textContent = `Some made to order pieces in your cart need extra time. The longest current lead time is ${maxRange} weeks for ${maxTitleText}.`;
      } else {
        state.header.textContent = `Some pieces in your cart will be made to order. The longest current lead time is ${maxRange} weeks for ${maxTitleText}.`;
      }
    }

    if (state.content) {
      state.content.innerHTML = `<ul class="hadley-toast__list">${overages.map((overage, index) => {
        const hidden = !state.expanded && index >= visibleLimit ? " hidden" : "";
        return `<li${hidden}>${lineText(overage)}</li>`;
      }).join("")}</ul>`;
    }

    if (state.toggleButton) {
      const hiddenCount = Math.max(overages.length - visibleLimit, 0);
      state.toggleButton.hidden = hiddenCount <= 0;
      state.toggleButton.textContent = state.expanded
        ? "Show fewer made to order items"
        : `Show ${hiddenCount} more made to order ${pluralize(hiddenCount, "item", "items")}`;
    }

    if (state.footer) {
      state.footer.textContent = totalMTO > 1
        ? "Your order will ship when the made to order pieces are finished."
        : "Your order will ship when the made to order piece is finished.";
    }

    state.toast.hidden = false;
  }

  function initToast(toast, snapshot = null) {
    if (!(toast instanceof HTMLElement) || toastStates.has(toast)) {
      return;
    }

    const explicitSurface = String(toast.getAttribute("data-hadley-mto-surface") || "").trim();
    const inDrawer = explicitSurface.endsWith("drawer") || Boolean(toast.closest("cart-drawer"));
    if (isCartPage() && inDrawer) {
      toast.hidden = true;
      return;
    }

    const surfaceKey = explicitSurface || (inDrawer ? "drawer" : "cart");
    if (registry[surfaceKey] && registry[surfaceKey] !== toast && registry[surfaceKey].isConnected) {
      toast.hidden = true;
      return;
    }
    registry[surfaceKey] = toast;

    const state = {
      toast,
      surfaceKey,
      inDrawer,
      header: toast.querySelector(".hadley-toast__header"),
      content: toast.querySelector(".hadley-toast__content"),
      footer: toast.querySelector(".hadley-toast__footer"),
      closeButton: toast.querySelector(".hadley-toast__close"),
      toggleButton: toast.querySelector(".hadley-toast__toggle"),
      currentCartKey: "",
      expanded: false,
      lastSnapshot: null
    };

    toastStates.set(toast, state);

    state.closeButton?.addEventListener("click", () => {
      dismissedBySurface[state.surfaceKey] = state.currentCartKey;
      hideToast(state);
    });

    state.toggleButton?.addEventListener("click", () => {
      state.expanded = !state.expanded;
      if (state.lastSnapshot) {
        renderToast(state, state.lastSnapshot);
      }
    });

    if (snapshot) {
      renderToast(state, snapshot);
    }
  }

  function initToasts(root = document, snapshot = window.HadleyMtoLeadTime?.currentSnapshot?.() || null) {
    if (root instanceof HTMLElement && root.matches("[data-hadley-mto-toast]")) {
      initToast(root, snapshot);
    }
    root.querySelectorAll?.("[data-hadley-mto-toast]").forEach((toast) => initToast(toast, snapshot));
  }

  function renderAllToasts(snapshot) {
    if (!snapshot) {
      return;
    }

    document.querySelectorAll("[data-hadley-mto-toast]").forEach((toast) => {
      const state = toastStates.get(toast);
      if (state) {
        renderToast(state, snapshot);
      } else {
        initToast(toast, snapshot);
      }
    });
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          initToasts(node);
        }
      });
    }
  });

  document.addEventListener("hadley:mto-snapshot", (event) => {
    renderAllToasts(event.detail?.snapshot);
  });

  initToasts();
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
